import React, { useState, useEffect, useRef } from 'react';

const OTPVerify = ({ voucherCode, email, onBack, onSuccess }) => {
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const inputRefs = useRef([]);

    useEffect(() => {
        if (inputRefs.current[0]) inputRefs.current[0].focus();
    }, []);

    const handleChange = (index, e) => {
        const val = e.target.value;
        if (isNaN(val)) return;

        const newOtp = [...otp];
        if (val.length > 1) {
            // Paste support
            const pastedData = val.slice(0, 6).split('');
            for (let i = 0; i < 6; i++) newOtp[i] = pastedData[i] || '';
            setOtp(newOtp);
            inputRefs.current[Math.min(pastedData.length, 5)].focus();
        } else {
            newOtp[index] = val;
            setOtp(newOtp);
            if (val !== '' && index < 5) inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && otp[index] === '' && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handleVerify = async (e) => {
        e.preventDefault();
        const otpString = otp.join('');
        if (otpString.length !== 6) {
            setError('Please enter the entire 6-digit code.');
            return;
        }
        setError('');
        setLoading(true);
        try {
            const response = await fetch('/wp-json/rll/v1/booking/verify-otp', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ voucher_code: voucherCode, email, otp: otpString }),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.message || 'Verification failed');
            onSuccess(data.token, data.voucher_data);
        } catch (err) {
            setError(err.message);
            setOtp(['', '', '', '', '', '']);
            inputRefs.current[0].focus();
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="rll-animate-in" style={{ maxWidth: 600, margin: '0 auto' }}>
            <div className="rll-otp-wrapper">
                <p className="rll-otp-sent-to">We sent a 6-digit code to</p>
                <p className="rll-otp-email">{email}</p>

                <form onSubmit={handleVerify}>
                    <div className="rll-otp-inputs">
                        {otp.map((digit, index) => (
                            <input
                                key={index}
                                ref={(el) => (inputRefs.current[index] = el)}
                                type="text"
                                inputMode="numeric"
                                autoComplete="one-time-code"
                                maxLength="6"
                                className={`rll-otp-input ${digit ? 'filled' : ''}`}
                                value={digit}
                                onChange={(e) => handleChange(index, e)}
                                onKeyDown={(e) => handleKeyDown(index, e)}
                                disabled={loading}
                            />
                        ))}
                    </div>

                    {error && <div className="rll-alert rll-alert--error" style={{ marginTop: '1.25rem' }}>{error}</div>}

                    <div style={{ marginTop: '1.5rem' }}>
                        <button
                            type="submit"
                            disabled={loading || otp.join('').length !== 6}
                            className="rll-btn rll-btn--primary"
                        >
                            {loading ? 'Verifying...' : 'Verify Secure PIN'}
                        </button>
                    </div>

                    <div className="rll-otp-actions">
                        <button type="button" onClick={onBack} className="rll-btn rll-btn--ghost" disabled={loading}>
                            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ marginRight: 4 }}>
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                            Back
                        </button>
                        <button type="button" className="rll-btn rll-btn--link" disabled={loading} onClick={onBack}>
                            Didn't receive code?
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default OTPVerify;
